import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { ApplicationElement } from './application_element.js';

import  { VERSION } from '../version.js';

import { styles as sharedStyles } from '../styles/shared-styles'

import '@shoelace-style/shoelace/dist/components/card/card.js';
import '../components/c-flux.js';
import '../components/flux-graph.js';
import '../components/sessions-pictogram.js'



@customElement('app-flux')
export class AppFlux extends ApplicationElement {
  static styles = [
    sharedStyles,
    css`
      main {
        text-align: center;
        color: var(--sl-color-neutral-600);
      }

      c-flux {
        margin-bottom: 2em;
      }

      figure {
        margin-block: 2em;

        h2 {
          color: var(--sl-color-emerald-600);
          font-size: 2.4em;
          margin: 0 0 0.2em;
        }
      }
    `
  ]

  @property({ type: Object }) config = this.state?.config;

  // Static config for App info
  @property({ type: Object }) appConfig: any = {
    version: VERSION
  };


  onStateChange({ state }) {
    this.config = state.config;
  }

  renderActualPlan() {
    if(!this.state?.actualPlan) return;

    const {fasting, eating} = this.state.actualPlan;

    return html`
      <figure class="actual-plan">
        <h2>${fasting} / ${eating}</h2>
        <figcaption>Your actual rhythm</figcaption>
      </figure>
    `
  }


  render() {
    console.log(this.state?.sessions)
    return html`
      <app-header title="Flux"></app-header>
      <main>
        <c-flux
          .totalFluxHuman=${this.state?.totalFluxHuman}
          .normalizedFluxOffset=${this.state?.normalizedFluxOffset}
          >
        </c-flux>

        <flux-graph .history=${this.state?.fluxHistory}></flux-graph>

        <figure class="days-stats">
          <h2>${this.state.sessionsCount}</h2>
          <figcaption>Days of fasting</figcaption>
        </figure>


        ${this.renderActualPlan()}

        <figure>
          <sessions-pictogram .sessions=${this.state?.sessions}></sessions-pictogram>
          <figcaption>Your fasting sessions</figcaption>
        </figure>
      </main>

      <app-footer></app-footer>
    `;
  }
}
